import classNames from 'classnames/bind';
import Button, { ButtonWithIconLeft } from 'koba/components/Button';
import Icon from 'koba/components/Icon';
import Modal from 'koba/components/Modal';
import { TFunction, withTranslation } from 'next-i18next';
import { WithTranslation } from 'react-i18next';

import React from 'react';

import styles from './ConfirmDeleteModal.module.scss';

const cx = classNames.bind(styles);

interface ConfirmDeleteModalProps extends WithTranslation {
  closeAction(): void;
  confirmDeleteBody: string | JSX.Element;
  confirmDeleteTitle: string;
  confirmDeleteButton?: string;
  deleteAction(): void;
  isConfirmModalOpen: boolean;
  isLoading?: boolean | null;
  t: TFunction;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  t,
  confirmDeleteBody,
  confirmDeleteTitle,
  confirmDeleteButton,
  isConfirmModalOpen,
  isLoading = false,
  closeAction,
  deleteAction,
}) => (
  <>
    <Modal
      closeModal={closeAction}
      footer={
        <>
          {/* @ts-ignore */}
          <Button appearance="ghost" onClick={closeAction}>
            {t('common-cancel', 'Cancel')}
          </Button>
          <ButtonWithIconLeft
            appearance="default"
            dataQA="confirm-delete__btn"
            isDisabled={isLoading || undefined}
            hasDanger
            onClick={deleteAction}
          >
            <Icon name="trash-can" />
            <div className={cx('confirm-delete__btn')}>
              {confirmDeleteButton || confirmDeleteTitle}
            </div>
            <div className={cx('confirm-delete__btn--mobile')}>{t('Delete')}</div>
          </ButtonWithIconLeft>
        </>
      }
      isOpen={isConfirmModalOpen}
      modalBodyClasses="modal__confirm-delete"
      title={confirmDeleteTitle}
    >
      <p>{confirmDeleteBody}</p>
    </Modal>
  </>
);

export default withTranslation()(ConfirmDeleteModal);
